import './processing.css';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { RotateCw, LayoutGrid, Code2, CheckCheck, Wand2 } from 'lucide-react';

const ICONS = [RotateCw, LayoutGrid, Code2, CheckCheck, Wand2];

const Process = () => {
    const { t } = useTranslation();

    return (
        <section className="process" aria-label={t("workflow")}>
            <div className="process__eyebrow">
                <span className="process__eyebrow-dash" aria-hidden="true" />
                {t("workflow")}
            </div>

            <div className="process__wrapper">
                <div className="process__line" aria-hidden="true" />

                <div className="process__steps" role="list">
                    {[1, 2, 3, 4, 5].map((step, i) => {
                        const Icon = ICONS[i];
                        return (
                            <motion.div
                                key={`step-${i}`}
                                className="process__step"
                                role="listitem"
                                initial={{ opacity: 0, x: -30 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6, delay: i * 0.15 }}
                                viewport={{ once: true, amount: 0.5 }}
                            >
                                <div className="process__number" aria-hidden="true">
                                    {i + 1}
                                </div>

                                <motion.div
                                    className="process__content"
                                    whileInView={{
                                        borderColor: 'rgba(168, 132, 255, 0.6)',
                                        backgroundColor: 'rgba(124, 92, 255, 0.06)',
                                    }}
                                    viewport={{ once: false, amount: 0.6 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="process__icon">
                                        <Icon size={20} strokeWidth={1.8} />
                                    </div>
                                    <div className="process__text">
                                        <h3>{t(`steps.${step}.title`)}</h3>
                                        <p>{t(`steps.${step}.text`)}</p>
                                    </div>
                                </motion.div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Process;